import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAccEntrepreneur } from '../all-entrepreneurs-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService, areaService: DeliveryAreaService): GridSetup<DeliveryAccEntrepreneur> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Entrepreneur', plural: 'Entrepreneurs' },
		getRowKey: row => '' + row.accEntrepreneurId,
		stateKey: 'delivery-all-entrepreneurs-grid',
		actions: getActions(dialog, areaService),
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Entrepreneurs`
		}
	}
}
